import React, { useState, useEffect, memo } from 'react'
import ReactModal from 'react-modal'
import { FaTimes } from 'react-icons/fa'
import { create } from '../../server/server'
import { useUser } from '../../auth'
import '../../styles/modals/CreateTargetFavoriteModal.css'
import { useTranslation } from 'react-i18next'

const CreateTargetFavoriteModal = memo(({ showFav, closeFav, checkedResults, type }) => {
    useEffect(() => {
        ReactModal.setAppElement('#home')
    }, [showFav])
    const [name, setName] = useState('')
    const closeModal = () => {
        resetValues()
        closeFav()
    }
    const { user, setUser } = useUser()
    const { t } = useTranslation()
    const [showErrorMessage, setShowErrorMessage] = useState(false)
    const handleSave = async () => {
        if (name === '') {
            setShowErrorMessage(true)
            return
        }
        setShowErrorMessage(false)
        const response = await create({
            collection: 'favorite_target',
            data: {
                name: name,
                target: checkedResults,
                type: type,
                user_id: user.id,
            },
        })
        if (response.status) {
            closeModal()
        }
    }

    const resetValues = () => {
        setName('')
        setShowErrorMessage(false)
    }

    return (
        <ReactModal
            closeTimeoutMS={600}
            isOpen={showFav}
            onRequestClose={closeModal}
            onAfterClose={resetValues}
            shouldCloseOnOverlayClick={true}
            style={{
                overlay: {
                    zIndex: 81,
                    backgroundColor: 'rgba(44,44,44,0.5)',
                },
                content: {
                    width: 400,
                    padding: 0,
                    margin: '0 auto',
                    marginTop: 200,
                    borderRadius: 16,
                    border: 'none',
                    backgroundColor: '#D7E2F8',
                    position: 'unset',
                },
            }}
        >
            <div className={`save_target-container `}>
                <div className="target-header">
                    <h2>{t('saveYourFavoriteGroup')}</h2>
                    <span className="close-modal-button">
                        <span className="cancel-poll-btn" onClick={() => closeFav()}>
                            <FaTimes />
                        </span>
                    </span>
                </div>
                <div className="target-body">
                    <div className="target-name-container">
                        <label htmlFor="name" className="target-name-label">
                            {t('name')}
                        </label>
                        <input
                            type="text"
                            className="target-name-input"
                            placeholder={t('name')}
                            value={name}
                            onChange={(e) => {
                                if (e.target.value !== '') setShowErrorMessage(false)
                                setName(e.target.value)
                            }}
                        />
                    </div>
                </div>
                <div className="mt-1">
                    <p className={`text-[#FF747F] font-medium text-[14px] text-center ${showErrorMessage ? '' : 'opacity-0'}`}>{t('fieldIsRequired')}</p>
                </div>
                <div className="target-footer">
                    <button className="target-cancel-button" onClick={() => closeFav()}>
                        {t('cancel')}
                    </button>
                    <button className="target-select-button" onClick={() => handleSave()}>
                        {t('save')}
                    </button>
                </div>
            </div>
        </ReactModal>
    )
})

export default CreateTargetFavoriteModal
